import _ from 'lodash';
import { isRequired, validateAddress } from '../validators';
// eslint-disable-next-line import/prefer-default-export
export const capitalizeSentenceWords = sentence => (_.isEmpty(sentence) ? '' : sentence.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()));

export const sanitizeSpecialChars = (sentence, replacementRegex) => (_.isEmpty(sentence) ? '' : sentence.replace(replacementRegex, char => sentence[char] || ' '));

export const trimSpaces = sentence => (_.isEmpty(sentence) ? '' : sentence.replace(/\s+/g, ' ').trim());

// eslint-disable-next-line no-nested-ternary
export const sanitizeHyphenatedLastName = lastName => (_.isEmpty(lastName) ? '' : (lastName.includes('-') ? `{${lastName}}` : lastName));


export const formatString = (value, pattern) => {
  let i = 0;
  const v = value.toString();
  // eslint-disable-next-line no-plusplus
  return pattern.replace(/#/g, () => v[i++]);
};

export const phoneParser = s => s && s.replace(/\D/g, '').substring(0, 10);

export const phoneFormatter = s => s && s.replace(/(\d{3})-?(\d{3})-?(\d{4})/, '$1-$2-$3');

// eslint-disable-next-line no-useless-escape
export const folioAllowedSpecialChars = /[\wa-zA-Z0-9\s~`!@#$%^&*()_+\-=\[\{\]\}|:',.\/? ]/g;

export const validatePrimaryAddress = (address) => {
  const required = isRequired(address);
  if (_.isEmpty(required)) {
    const valid = validateAddress(address);
    return valid ? undefined : `The following characters are not allowed: ${
      address.replace(folioAllowedSpecialChars, '').split('')
        .filter((item, pos, self) => self.indexOf(item) === pos)
        .join('')}`;
  }
  return undefined;
};

export const validateSecondaryAddress = (address) => {
  if (_.isEmpty(address)) return undefined;
  const valid = validateAddress(address);
  return valid ? undefined : `The following characters are not allowed: ${
    address.replace(folioAllowedSpecialChars, '').split('')
      .filter((item, pos, self) => self.indexOf(item) === pos)
      .join('')}`;
};


export const validateRepresentatives = (value, allValues) => {
  if (allValues.solicited && _.isEmpty(value)) {
    return 'Required';
  }
  return undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/utils.js